export default __webpack_public_path__ + "static/11.mosaic-128fc1c67da3cba4abb802f417f0f85c.png";